import React from "react";
import { Toaster } from "react-hot-toast";
import MyRouter from "routers/index";
import { setSiteVisits } from "Services/API/Put";
import MetaPixel from "utils/metaPixel"
function App() {
  React.useEffect(() => {

    setSiteVisits()
      .then((res) => {
        console.log("sitevisit>>>>", res);
      })
      .catch((error) => {
        console.error(">errorrrrr>", error);

      });

  })

  return (
    <>
      <MetaPixel />
      <div>
        <Toaster />
      </div>
      {/* MAIN APP */}
      <div className="bg-white text-base dark:bg-[#002930] text-slate-900 dark:text-slate-200">
        <MyRouter />
      </div>
    </>
  );
}

export default App;
